import React from "react";
import { IconSearch } from "../../icons/Icon";
import "../../assets/styles/smu-search.scss";
import { COLOR_PRIMARY } from "../../constants/colors";

const SmuSearch = ({ _className, placeholder, value, onChange, action }) => {
  const handleEnter = (event) => {
    if ((event.which === 13 || event.keyCode === 13) && !!action) action(value);
  };

  return (
    <div className={`smu-search px-3 ${_className}`}>
      <input
        text="serach"
        placeholder={placeholder || "Buscar"}
        value={value}
        onChange={onChange}
        onKeyPress={(event) => handleEnter(event)}
      />
      {action ? (
        <button className="action-search" onClick={() => action(value)}>
          <IconSearch color={COLOR_PRIMARY} />
        </button>
      ) : (
        <IconSearch color={COLOR_PRIMARY} />
      )}
    </div>
  );
};

export default SmuSearch;
